export default function OpenFile(urlFile) {
    window.open(urlFile, "_blank");
}